import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import registerServiceWorker from './registerServiceWorker';
import { Provider } from "react-redux";
import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import Keycloak from 'keycloak-js';
import axios from "axios";

import caseReducer from "./components/CaseSelector/store/reducer";
import ownedCaseReducer from "./components/Purchases/store/reducer";
import commissionReducer from "./commissions/redux/reducers";
import dandoReducer from "./dandos/redux/reducers";
import aceAlertsReducer from "./ace/redux/reducers"
import dandoAdminReducer from "./components/Admin/storeDandO/reducer";
import aceAlertAdminReducer from "./components/Admin/storeAceAlerts/reducer";
import settlementRateAdminReducer from "./components/SettlementRate/redux/reducers";
import firmReducer from "./settings/firm/redux/reducers";
import publicationReducer from "./publications/redux/reducers";
import currentCaseReducer from "./components/DamageReports/BasicDamageReport/store/reducer"
import { AUTH_URI } from "./config";
import { Route, Switch } from "react-router-dom";
import Layout from "./components/Layout/Layout";
import LayoutAdmin from "./components/Layout/LayoutAdmin";
import LayoutRegister from "./components/Layout/LayoutRegister";
import { createBrowserHistory } from 'history'
import { connectRouter, routerMiddleware, ConnectedRouter } from 'connected-react-router';
import 'react-notifications/lib/notifications.css';
import { NotificationContainer } from 'react-notifications';

import "./App.css"
import CaseSelector from "./components/CaseSelector/CaseSelector";
import Risks from "./components/Risks/Risks";
import MyCases from "./components/MyCases/MyCases";
import BasicDamageReport from "./components/DamageReports/BasicDamageReport/BasicDamageReport";
import ClassWideDamageReport from "./components/DamageReports/ClassWideDamageReport/ClassWideDamageReport";
import PurchaseComponent from "./components/Purchases/PurchaseComponent";
import {
	COMMISSION_SELECTION_ROUTE,
	COMMISSION_CREATION_ROUTE,
	COMMISSION_UPDATION_ROUTE,
	COMMISSION_DAMAGES_ROUTE
} from "./commissions/routes/routes";
import {
	DANDO_SELECTION_ROUTE,
	DANDO_CREATION_ROUTE,
	DANDO_DUPLICATION_ROUTE,
	DANDO_UPDATION_ROUTE
} from "./dandos/routes/routes";
import {
	ACE_SELECTION_ROUTE, ACE_ADD_COMPANIES_ROUTE
} from "./ace/routes/routes";
import {
	PUBLICATION_SELECTION_ROUTE/*,
	DANDO_CREATION_ROUTE,
	DANDO_UPDATION_ROUTE*/
} from "./publications/routes/routes";
import FirmSettingContainer from "./settings/firm/component/FirmSettingContainer";
import CaseManagement from "../src/components/Admin/CaseManagement";
import CustomCaseManagement from "../src/components/Admin/CustomCaseManagement";
import DandOManagement from "../src/components/Admin/DandOManagement";
import AceAlertsManagament from './components/Admin/AceAlertsManagament';
import ManagingPurchases from "../src/components/Admin/ManagingPurchases";
import SettlementRatesManagement from "../src/components/Admin/SettlementRateManagement";
import Register from "./components/Register/register";
import { apiUri } from "./config";
import Congratulations from './components/Register/congratulations';
import Thankyou from './components/Register/thankyou';
import CookieConsent from "react-cookie-consent";

const rootReducer = combineReducers({
	cases: caseReducer,
	ownedCases: ownedCaseReducer,
	currentCase: currentCaseReducer,
	commissions: commissionReducer,
	dandos: dandoReducer,
	aceAlerts:aceAlertsReducer,
	firmSettings: firmReducer,
	dandoAdmin: dandoAdminReducer,
	aceAlertsAdmin: aceAlertAdminReducer,
	settlementRateAdmin: settlementRateAdminReducer,
	publications: publicationReducer
});

const history = createBrowserHistory();
const store = createStore(
	connectRouter(history)(rootReducer),
	compose(
		applyMiddleware(
			routerMiddleware(history),
			thunk
		)
	)
);

const keycloak = new Keycloak({
	"realm": "SAR",
	"url": AUTH_URI,
	"ssl-required": "external",
	"resource": "public_client",
	"public-client": true,
	"clientId": "public_client"
});

const token = localStorage.getItem('keycloak_token');
const refreshToken = localStorage.getItem('keycloak_refreshToken');
let isAdmin;

const unauthenticatedPaths = ['/Register', '/Congratulations', '/Thankyou'];
const currentPath = window.location.pathname;

if (unauthenticatedPaths.includes(currentPath)) {
	// Render the unauthenticated component directly
	ReactDOM.render(
		<Provider store={store}>
			<ConnectedRouter history={history}>
				<LayoutRegister>
					<Switch>
						<Route path="/Register" exact component={Register} />
						<Route path="/Thankyou" exact component={Thankyou} />
						<Route path="/Congratulations" exact component={Congratulations} />
					</Switch>
					<CookieConsent
            			location="bottom"
            			buttonText="I ACCEPT"
            			cookieName="myAwesomeCookieName2"
            			style={{ background: "#2B373B", alignItems: "center", fontSize: "10px" }}
            			buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
            			expires={365}
          			>
            			Cookies; Terms and Conditions; Privacy Policy: This website uses
            			cookies to improve your experience. For more information on how
            			cookies are used, please read our <a href="https://www.sarlit.com/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>. 
            			By clicking “I Accept” or continuing on our website, you agree to our <a href="https://www.sarlit.com/terms-conditions" target="_blank" rel="noopener noreferrer">Terms and Conditions</a> and <a href="https://www.sarlit.com/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>. 
            			If you do not want to agree to our <a href="https://www.sarlit.com/terms-conditions" target="_blank" rel="noopener noreferrer">Terms and Conditions</a> and <a href="https://www.sarlit.com/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>, you must not access or use
            			our website.
          			</CookieConsent>
				</LayoutRegister>
			</ConnectedRouter>
		</Provider>,
		document.getElementById('root')
	);
} else {

keycloak.init({ onLoad: 'login-required', token, refreshToken }).then(authenticated => {
	if (authenticated) {
		var config = {
			headers: { 'Authorization': "Bearer " + token }
		};

		localStorage.setItem('isAdminToken', false);
		updateLocalStorage();
		axios.get(apiUri + "/firms/isAdmin",
			config)
			.then(response => {
				isAdmin = response.data.content.isAdmin;
				localStorage.setItem('isAdminToken', isAdmin);
				if (isAdmin) {
					if(history.location.pathname === '/') {
						history.push("/CaseManagement");
					}
					ReactDOM.render(
						<Provider store={store}>
							<ConnectedRouter history={history}>
								<div className={"App"}>
									<LayoutAdmin history={history} isAdmin={[{ value: isAdmin }]} keycloak={keycloak}  >
										<Switch>
											
											<Route path="/" exact component={CaseManagement} />
											<Route path="/cases" exact component={CaseSelector} />
											<Route path="/cases/:caseId" exact component={BasicDamageReport} />
											<Route path="/cases/:caseId/classwide" exact
												component={ClassWideDamageReport} />
											<Route path="/cases/:caseId/purchase" exact component={PurchaseComponent} />
											{COMMISSION_SELECTION_ROUTE}
											{COMMISSION_CREATION_ROUTE}
											{COMMISSION_UPDATION_ROUTE}
											{COMMISSION_DAMAGES_ROUTE}
											{DANDO_SELECTION_ROUTE}
											{ACE_SELECTION_ROUTE}
											{ACE_ADD_COMPANIES_ROUTE}
											{DANDO_CREATION_ROUTE}
											{DANDO_UPDATION_ROUTE}
											{DANDO_DUPLICATION_ROUTE}
											<Route path="/CaseManagement" exact component={CaseManagement} />
											<Route path="/CustomCaseManagement" exact component={CustomCaseManagement} />
											<Route path="/DandOManagement" exact component={DandOManagement} />
											<Route path="/AceAlertsManagement" exact component={AceAlertsManagament} />
											<Route path="/ManagingPurchases" exact component={ManagingPurchases} />
											<Route path="/SettlementRatesManagement" exact component={SettlementRatesManagement} />
										</Switch>
									</LayoutAdmin>
									<FirmSettingContainer />
									<NotificationContainer />
								</div>
							</ConnectedRouter>
						</Provider>, document.getElementById('root')
					);
				} else {
					ReactDOM.render(
						<Provider store={store}>
							<ConnectedRouter history={history}>
								<div className={"App"}>
									<Layout keycloak={keycloak} history={history}>
										<Switch>
											<Route path="/" exact component={CaseSelector} />
											<Route path="/cases/:caseId" exact component={BasicDamageReport} />
											<Route path="/cases/:caseId/classwide" exact
												component={ClassWideDamageReport} />
											<Route path="/cases/:caseId/purchase" exact component={PurchaseComponent} />

											<Route path="/risks" exact component={Risks} />
											<Route path="/mycases" exact component={MyCases} />
											{COMMISSION_SELECTION_ROUTE}
											{COMMISSION_CREATION_ROUTE}
											{COMMISSION_UPDATION_ROUTE}
											{COMMISSION_DAMAGES_ROUTE}
											{DANDO_SELECTION_ROUTE}
											{ACE_SELECTION_ROUTE}
											{ACE_ADD_COMPANIES_ROUTE}
											{DANDO_CREATION_ROUTE}
											{DANDO_UPDATION_ROUTE}
											{DANDO_DUPLICATION_ROUTE}
											{PUBLICATION_SELECTION_ROUTE}
										</Switch>
									</Layout>
									<FirmSettingContainer />
									<NotificationContainer />
									<CookieConsent
            							location="bottom"
            							buttonText="I ACCEPT"
            							cookieName="myAwesomeCookieName2"
            							style={{ background: "#2B373B", alignItems: "center" , fontSize: "10px"}}
            							buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
            							expires={365}
          							>
            							Cookies; Terms and Conditions; Privacy Policy: This website uses
            							cookies to improve your experience. For more information on how
            							cookies are used, please read our <a href="https://www.sarlit.com/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>. By clicking “I
            							Accept” or continuing on our website, you agree to our <a href="https://www.sarlit.com/terms-conditions" target="_blank" rel="noopener noreferrer">Terms and Conditions</a> and <a href="https://www.sarlit.com/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>. If you do not want to agree to our
            							<a href="https://www.sarlit.com/terms-conditions" target="_blank" rel="noopener noreferrer">Terms and Conditions</a> and <a href="https://www.sarlit.com/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>, you must not access or use
            							our website.
          							</CookieConsent>
								</div>
							</ConnectedRouter>
						</Provider>, document.getElementById('root')
					);
				}
			}).catch(err => {
				ReactDOM.render(
					<Provider store={store}>
						<ConnectedRouter history={history}>
							<div className={"App"}>
								<Layout keycloak={keycloak}>
									<Switch>
										{/* <Route path="/reload" component={null} key="reload" /> */}
										<Route path="/" exact component={CaseSelector} />
										<Route path="/cases/:caseId" exact component={BasicDamageReport} />
										<Route path="/cases/:caseId/classwide" exact
											component={ClassWideDamageReport} />
										<Route path="/cases/:caseId/purchase" exact component={PurchaseComponent} />
										{COMMISSION_SELECTION_ROUTE}
										{COMMISSION_CREATION_ROUTE}
										{COMMISSION_UPDATION_ROUTE}
										{COMMISSION_DAMAGES_ROUTE}
										{DANDO_SELECTION_ROUTE}
										{ACE_SELECTION_ROUTE}
										{ACE_ADD_COMPANIES_ROUTE}
										{DANDO_CREATION_ROUTE}
										{DANDO_UPDATION_ROUTE}
										{PUBLICATION_SELECTION_ROUTE}
									</Switch>
								</Layout>
								<FirmSettingContainer />
								<NotificationContainer />
							</div>
						</ConnectedRouter>
					</Provider>, document.getElementById('root')
				);
			});

	} else {
		ReactDOM.render(<h2>Failed to auth</h2>)
	}
}).catch(abc => console.log("issues", abc));
}
const updateLocalStorage = () => {
	localStorage.setItem('keycloak_token', keycloak.token);
	localStorage.setItem('keycloak_refreshToken', keycloak.refreshToken);
};

if (!unauthenticatedPaths.includes(currentPath)) {
  axios.interceptors.request.use((config) =>
    keycloak
      .updateToken(5)
      .then((refreshed) => {
        if (refreshed) {
          updateLocalStorage();
        }
        config.headers.Authorization = "Bearer " + keycloak.token;
        return Promise.resolve(config);
      })
      .catch(() => {
        keycloak.login();
      })
  );
}

try {
	registerServiceWorker();
} catch (e) {
	console.log("unable to register service worker ", e)
}



// WEBPACK FOOTER //
// ./src/index.js